import { useRouter } from "next/router";
import { fetchRemoveAuthCookies } from "../api";

type UseExitReturn = {
  logOut: () => void;
};
/**
 * Hook return callback for logout
 * @param redirect - to main page // default value true
 * @return logOut - handler for logout
 * @example
 * const {logOut} = useLogOut;
 * <Button onClick={logOut}> Exit </Button>
 */
export const useLogOut = (redirect: boolean = true): UseExitReturn => {
  const router = useRouter();

  const logOut = async (): Promise<void> => {
    await fetchRemoveAuthCookies();
    if (redirect) await router.push(`/`);
  };

  return {
    logOut,
  };
};
